import Api from '../../path';
import { fetchData } from '@umu/umu-fetch'; 

export const setElementOrder = (courseId: string | number, isReverse: boolean): Promise<IStatusResponse> => {
    const param = {
        option_type: 3,
        option_obj_id: courseId,
        option_value: isReverse ? 2 : 1,
    };
	return fetchData(Api.UPDATE_USER_SETUP, param).then((res: IStatusResponse) => {
		return res;
	});
};
